angular.module('shared').directive('waiverStripePaymentDetails', function() {
  return {
    restrict: 'E',
    scope: {
      waiver: '=',
      walletDetails: '=',
      pageParams: '=',
      gymCountry: '=',
      saveWaiver: '&',
      isPaymentDetailsInvalid: '&'
    },
    template: require('templates/shared/waivers/payment_details/waiver_stripe_payment_details.html.slim'),
    controller: ["$scope", "$timeout", "$document", "CreditCardValidationService", "loadingAnimation", function($scope, $timeout, $document, CreditCardValidationService, loadingAnimation) {
      var cardElement, elements, onCardChange, onError, publicKey, saveCardDetails, stripe;
      publicKey = $scope.waiver.gym_payment_provider === 'stripe' ? $scope.waiver.gym_public_key : $scope.waiver.gym_secondary_public_key;
      stripe = Stripe(publicKey);
      elements = stripe.elements();
      cardElement = elements.create('card');
      cardElement.mount('#card');
      $scope.$watch('walletDetails', function(newWalletDetails) {
        return cardElement.update({
          disabled: !newWalletDetails.editable
        });
      });
      $scope.nameValid = function() {
        var ref;
        return CreditCardValidationService.nameValid((ref = $scope.walletDetails) != null ? ref.nameOnCard : void 0);
      };
      onCardChange = function() {
        return cardElement.on('change', function(event) {
          return $timeout(function() {
            var displayErrorEl;
            displayErrorEl = document.getElementById('cardErrors');
            $scope.walletDetails.complete = event.complete;
            if (event.error) {
              return displayErrorEl.textContent = event.error.message;
            } else if (event.complete) {
              return displayErrorEl.textContent = '';
            }
          });
        });
      };
      onCardChange();
      $scope.save = function() {
        var clientSecret, options;
        clientSecret = $scope.waiver.stripe_setup_intent_attributes.client_secret;
        options = {
          billing_details: {
            name: document.getElementById('nameOnCard').value
          }
        };
        $document.scrollTop(0);
        return stripe.confirmCardSetup(clientSecret, {
          payment_method: {
            card: cardElement,
            billing_details: options.billing_details
          }
        }).then(function(setupIntentResult) {
          return $timeout(function() {
            var paymentMethodId;
            if (setupIntentResult.error) {
              if (window.Rollbar) {
                window.Rollbar.error('Stripe card setup error', setupIntentResult.error);
              }
              return onError('We are unable to authenticate your payment method. Please choose a different payment method and try again.');
            } else {
              paymentMethodId = setupIntentResult.setupIntent.payment_method;
              return stripe.createPaymentMethod('card', cardElement, options).then(function(createPaymentMethodResponse) {
                return $timeout(function() {
                  return saveCardDetails(paymentMethodId, createPaymentMethodResponse.paymentMethod);
                });
              });
            }
          });
        });
      };
      saveCardDetails = function(token, paymentMethod) {
        $scope.walletDetails.customer_ref = token;
        $scope.walletDetails.payment_method = 'credit_card';
        $scope.walletDetails.payment_provider = 'stripe';
        $scope.walletDetails.card_brand = paymentMethod.card.brand;
        $scope.walletDetails.exp_month = paymentMethod.card.exp_month;
        $scope.walletDetails.exp_year = paymentMethod.card.exp_year;
        $scope.walletDetails.full_name = document.getElementById('nameOnCard').value;
        $scope.walletDetails.last4 = paymentMethod.card.last4;
        $scope.walletDetails.address_zip = paymentMethod.billing_details.address.postal_code;
        $scope.waiver.signed_waiver_wallet_detail_attributes = angular.extend($scope.waiver.signed_waiver_wallet_detail_attributes, $scope.walletDetails);
        return $scope.saveWaiver();
      };
      return onError = function(error) {
        return $timeout(function() {
          $scope.pageParams.isLoading = false;
          loadingAnimation.hide();
          $scope.walletDetails.error = error;
          return $document.scrollToElementAnimated(angular.element('#walletDetails'));
        });
      };
    }]
  };
});
